import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import Button from 'Components/Button/Button';
import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';

const ExternalProductionDaysEmployee = ({
    productionsDaysIdSelecteds,
    productionsEmployeesSelecteds,
    setProductionsEmployeesSelecteds,
    setOperationsDaySelecteds,
    isOpen
}) => {
    const [inserting, setInserting] = useState(false);
    const [idProductionsEmployeesDays, setIdProductionsEmployeesDays] = useState([]);

    const attributeListGrid = [
        { name: "id", value: productionsEmployeesSelecteds, setter: setProductionsEmployeesSelecteds }
    ];

    const attributeListDetail = [
        { name: "id", value: idProductionsEmployeesDays, setter: setIdProductionsEmployeesDays, allowsMultipleRecordsSelected: true }
    ];

    const [recordsProductionDaysByUserId, setRecordsProductionDaysByUserId] = useState(null);
    const [attributesDetailProductionDaysPanel, setAttributesDetailProductionDaysPanel] = useState(null);
    const [loadingProductionDaysPanel, setLoadingProductionDaysPanel] = useState(null);
    const [enablePrintButton, setEnablePrintButton] = useState(null);

    // Só busca com o painel aberto; a grid depende do dia selecionado (salvar/excluir já recarregam)
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        reloadListProductionDays()
    }, [productionsDaysIdSelecteds, isOpen]);

    useEffect(() => {
        setOperationsDaySelecteds([])
    }, [productionsEmployeesSelecteds]);


    const fetchDataDetail = async (productionsDayIdSelected) => {
        const parameters = { externalProductionDayId: productionsDayIdSelected }
        const productionDays = await ExecuteAxios.api('get', `/external-employee-day/is-active-list/`, { params: parameters })
        if (productionDays) {
            setAttributesDetailProductionDaysPanel(productionDays)
        }
    };

    useEffect(() => {
        setIdProductionsEmployeesDays([])
        if (!isOpen) {
            return;
        }
        getDetailInformation();
    }, [inserting, isOpen]);

    function getDetailInformation() {
        if (productionsDaysIdSelecteds && productionsDaysIdSelecteds.length > 0) {
            fetchDataDetail(productionsDaysIdSelecteds[0]);
        }
        else {
            fetchDataDetail(null);
        }
    }

    async function getProductionDaysRecords(productionsDayIdSelected) {
        const parameters = { externalProductionDayId: productionsDayIdSelected }
        const productionDays = await ExecuteAxios.api('get', `/external-employee-day/grid/`, { params: parameters });
        setRecordsProductionDaysByUserId(productionDays);
        RemoveIdsNotFound.remove(productionDays, setProductionsEmployeesSelecteds, productionsDayIdSelected)
    }

    const getProductionDaysPanelListOrDetail = () => {
        if (!inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setProductionsEmployeesSelecteds}
                    idsSelected={productionsEmployeesSelecteds}
                    data={recordsProductionDaysByUserId}
                    attributeList={attributeListGrid}
                />
            )
        } else {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setIdProductionsEmployeesDays}
                    idsSelected={idProductionsEmployeesDays}
                    data={attributesDetailProductionDaysPanel}
                    attributeList={attributeListDetail}
                />
            )
        }
    }

    async function postEmployeesDays() {
        try {
            setLoadingProductionDaysPanel(true)
            const response = await ExecuteAxios.api('post', `/external-employee-day/`, {
                externalProductionDayId: productionsDaysIdSelecteds[0],
                externalEmployeesId: idProductionsEmployeesDays
            });

            if (response) {
                await reloadListProductionDays()
            }

            return response
        } finally {
            setLoadingProductionDaysPanel(false)
        }
    }

    async function reloadListProductionDays() {
        if (productionsDaysIdSelecteds && productionsDaysIdSelecteds.length === 1) {
            await getProductionDaysRecords(productionsDaysIdSelecteds[0])
        } else {
            await getProductionDaysRecords(0)
        }
    }

    async function deleteEmployeesDays() {
        try {
            setLoadingProductionDaysPanel(true)
            const response = await ExecuteAxios.api('delete', `/external-employee-day/`, {
                params: {
                    externalEmployeesIdSelected: productionsEmployeesSelecteds.join(",")
                }
            });

            if (response) {
                await reloadListProductionDays()
            }

            return response
        } finally {
            setLoadingProductionDaysPanel(false)
        }
    }

    const stylePrintButton = {
        float: 'right',
        color: (!productionsEmployeesSelecteds || productionsEmployeesSelecteds.length === 0) ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    function getPrintButton() {
        return (
            <Button
                clickMethod={() => { setToEnablePrintPanel() }}
                buttonName={'Imprimir relatório'}
                style={stylePrintButton}
                disabled={!productionsEmployeesSelecteds || productionsEmployeesSelecteds.length === 0}
                readOnly={!productionsEmployeesSelecteds || productionsEmployeesSelecteds.length === 0}
            />
        )
    }

    async function setToEnablePrintPanel() {
        balancePrint(productionsDaysIdSelecteds)
    }

    async function balancePrint(productionsDaysIdSelecteds) {
        try {
            const base64PDF = await ExecuteAxios.api('get', `/external-employee-day/reports/`,
                {
                    params: {
                        externalProductionDayId: productionsDaysIdSelecteds[0],
                        externalEmployeeId: productionsEmployeesSelecteds.join(",")
                    },
                    responseType: 'blob'
                });
            const blob = new Blob([base64PDF], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            window.open(url, '_blank');
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <LoadingIndicator loaded={!loadingProductionDaysPanel}>
            <Panel
                style={{ display: 'flex', height: '100%', flexDirection: 'column' }}
                setInserting={setInserting}
                inserting={inserting}
                enableNewRecord={true}
                canNewRecord={productionsDaysIdSelecteds && productionsDaysIdSelecteds.length === 1}
                postFunction={postEmployeesDays}
                deleteFunction={deleteEmployeesDays}
                canDelete={productionsEmployeesSelecteds && productionsEmployeesSelecteds.length > 0}
                enableDelete={true}
                canViewCRUD={true}
                recordsSelected={productionsEmployeesSelecteds}
                dataListedAttributes={attributesDetailProductionDaysPanel}
                onUpdateIdSelected={setProductionsEmployeesSelecteds}
                allButtonsToolBar={false}
                buttonsToolBar={getPrintButton()}
            >
                {getProductionDaysPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );
};

export default ExternalProductionDaysEmployee;


